import React from 'react';
import styled from 'styled-components';
import Icon from './Icon';
import {Wrapper, Text, IconWrapper} from '../styles';

const OrderTechnicalDifficulty = () => {
  return (
    <Wrapper>
      <IconWrapper>
        <Icon className={'fa fa-check-circle'} />
      </IconWrapper>
      <Text id="OrderSubmitted-OrderPlaced">
        Your order has been placed - but we are experiencing some technical
        difficulty in retrieving your order status. To get an update on your
        order, please contact the store.
      </Text>
    </Wrapper>
  );
};

export default OrderTechnicalDifficulty;
